import * as React from 'react';
import { observer } from 'mobx-react';
import { WorkflowConfiguration } from 'nomst/Stores/Configuration/workflowConfiguration';
import { IWorkflowRule } from 'typings/workflowRule';
import * as actions from 'nomst/Actions/configurations';
import WorkflowRule from 'nomst/Components/WorkflowSettings/workflowRule';
import WorkflowMenu from 'nomst/Components/WorkflowSettings/workflowMenu';
import './workflowRulesSection.scss';

export interface IWorkflowRulesSectionProps {
    workflowConfiguration: WorkflowConfiguration;
    updatePreviewCallback: () => Promise<void>;
    readonly?: boolean;
}

export class WorkflowRulesSection extends React.Component<IWorkflowRulesSectionProps> {
    constructor(props: IWorkflowRulesSectionProps) {
        super(props);

        this.handleExportWorkflow = this.handleExportWorkflow.bind(this);
        this.handleWorkflowCancel = this.handleWorkflowCancel.bind(this);
        this.handleWorkflowSave = this.handleWorkflowSave.bind(this);
    }

    render(): React.ReactNode {
        const { workflowConfiguration } = this.props;
        return (
            <div className="nomst-workflow-rules-section">
                <h2 className="nomst-workflow-rules-section__headline">1st Reviewer</h2>
                <div className="nomst-workflow-rules-section__rules">
                    {workflowConfiguration.rules.map((rule, index) => this.renderRule(rule, index))}
                    {this.renderAddWorkflowRuleButton()}
                </div>
                <div className="nomst-workflow-rules-section__actions">
                    {this.renderWorkflowActions()}
                </div>
            </div>
        );
    }

    private renderRule(rule: IWorkflowRule, index: number): React.ReactNode {
        const { workflowConfiguration, readonly } = this.props;
        return (
            <WorkflowRule
                key={index}
                rule={rule}
                workflowConfiguration={workflowConfiguration}
                readonly={readonly}
            />
        );
    }

    private renderAddWorkflowRuleButton(): React.ReactNode {
        const { workflowConfiguration, readonly } = this.props;
        if (readonly) {
            return null;
        }

        return (
            <WorkflowMenu
                workflowConfiguration={workflowConfiguration}
            />
        );
    }

    private renderWorkflowActions(): React.ReactNode {
        const { workflowConfiguration } = this.props;
        if (workflowConfiguration.hasChanges) {
            const disabled = workflowConfiguration.rules.length === 0;
            return (
                <>
                    <button
                        className="nomst-workflow-rules-section__cancel-btn pxl-link"
                        onClick={this.handleWorkflowCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="nomst-workflow-rules-section__save-btn pxl-btn pxl-btn--primary"
                        onClick={this.handleWorkflowSave}
                        disabled={disabled}
                    >
                        Save
                    </button>
                </>
            );
        }

        return (
            <button
                onClick={this.handleExportWorkflow}
                className="nomst-workflow-rules-section__export-btn pxl-link"
            >
                <i className="icon-download" />
                Export Full Workflow
            </button>
        );
    }

    private handleExportWorkflow(): Promise<void> {
        const { workflowConfiguration } = this.props;
        return workflowConfiguration.exportFullWorkflowToCsv();
    }

    private handleWorkflowCancel(): void {
        const { workflowConfiguration } = this.props;
        workflowConfiguration.revertRules();
    }

    private async handleWorkflowSave(): Promise<void> {
        const { workflowConfiguration, updatePreviewCallback } = this.props;
        await actions.saveWorkflowConfiguration(workflowConfiguration);
        await updatePreviewCallback();
    }
}

export default observer(WorkflowRulesSection);